import http from '../utils/http';

const baseRoute = '/operacao/monitoramento';

export default {
    buscarDadosMonitoramento(idOperacao) {
        return http.get({
            url: baseRoute + `/${idOperacao}`,
            lockScreen: true,
            lockMessage: 'Buscando dados de monitoramento'
        });
    },

    buscarDadosAnaliseTerritorio(idOperacao, idTerritorio) {
        return http.get({
            url: baseRoute + `/${idOperacao}/territorio/${idTerritorio}`,
            lockScreen: true,
            lockMessage: 'Buscando dados de análise do território'
        });
    },

    buscarDadosAnalisePessoa(idOperacao, idPessoa) {
        return http.get({
            url: baseRoute + `/${idOperacao}/pessoa/${idPessoa}`,
            lockScreen: true,
            lockMessage: 'Buscando dados de análise da pessoa'
        });
    },

    buscarOperacoesInibicao(payload) {
        return http.post({
            url: baseRoute + '/operacoes-inibicao',
            data: payload,
            lockScreen: false
        });
    },
    buscarJustificativasInibirRestricoes() {
        return http.get({
            url: baseRoute + '/justificativas-inibicao',
            lockScreen: false
        });
    },
    inibirRestricao(payload) {
        return http.post({
            url: baseRoute + '/inibicao-restricao',
            data: payload,
            lockScreen: true
        });
    },
    buscarInibicaoRestricaoOperacao(payload) {
        return http.post({
            url: baseRoute + '/buscar/inibicao',
            data: payload,
            lockScreen: true
        });
    }
};
